import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './environments/home/home.component';
import { AccessDeniedComponent } from './environments/access-denied/access-denied.component';
import { AuthGuard } from './guards/authGuard';
import { RoleGuard } from './guards/roleGuard';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'home',
                canActivate: [AuthGuard],
                component: HomeComponent,
                pathMatch: 'full',
                data: { animation: 'home' },
                title: 'LH | Home',
            },
            {
                path: 'access-denied',
                component: AccessDeniedComponent,
                title: 'LH | Access Denied',
            },
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            {
                path: 'base-stock-and-waxes',
                canActivate: [RoleGuard],
                data: { animation: 'home', requiredRole: 'baseandwaxesreader' },
                loadChildren: () =>
                    import(
                        './base-stock-and-waxes/base-stock-and-waxes.module'
                    ).then((m) => m.BaseStockAndWaxesModule),
            },
            {
                path: 'cogs',
                canActivate: [RoleGuard],
                data: { animation: 'home', requiredRole: 'cogsreader' },
                loadChildren: () =>
                    import('./cogs/cogs.module').then((m) => m.CogsModule),
            },
            {
                path: 'fl',
                canActivate: [RoleGuard],
                data: { animation: 'home', requiredRole: 'finishedlubesreader' },
                loadChildren: () =>
                    import('./fl/fl.module').then((m) => m.FlModule),
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'home',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
